// src/pages/MyPage/CancelUserComplete.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Smile from "../../../assets/icons/Cancel/Smile.svg"
import close from "../../../assets/icons/System/close.svg"
import { HeaderIconL } from "../../../assets/components/HeaderGroup";
import { SingleButton } from "../../../assets/components/ButtonGroup";

const CancelUserComplete = () => {
  const navigate = useNavigate();

  const goToRegister = () => {
    // 탈퇴 완료 후 시작 화면(회원가입/로그인)으로 이동
    navigate("/ads/register?step=0", { replace: true });
  };

  return (
    <div className="flex min-h-dvh flex-col">
      {/* 상단 닫기(X) 버튼 - 상단 고정 느낌 나도록 여백만 */}
      <header>
        <HeaderIconL title="" icon={close} onIconClick={goToRegister} />
      </header>

      {/* 중앙 이모지 + 메시지 */}
      <main className="flex flex-1 flex-col items-center justify-center text-center">
        <img
          src={Smile}
          alt="smile"
        />

        <p className="text-t2 text-text-default font-semibold pt-12 mb-[12px]">
          회원 탈퇴가 완료되었어요
        </p>

        <p className="text-b1 text-text-subtler leading-[22px]">
          wizMarket을 이용해 주셔서 감사합니다.
          <br />
          마음이 바뀌면 언제든 다시 돌아와 주세요.
        </p>
      </main>

      {/* 하단 확인 버튼 */}
      <footer>
        <SingleButton onClick={goToRegister}>확인</SingleButton>
      </footer>
    </div>
  );
};

export default CancelUserComplete;
